import React, {Fragment, useContext, useState} from 'react';
import {useFormik} from 'formik';
import * as yup from 'yup';
import {
    EuiBreadcrumbs,
    EuiButton,
    EuiDatePicker,
    EuiDatePickerRange,
    EuiDescribedFormGroup,
    EuiForm,
    EuiFormRow, EuiLink,
    EuiPageContent,
    EuiPageContentHeader,
    EuiPageContentHeaderSection,
    EuiPanel,
    EuiSpacer,
    EuiText
} from "@elastic/eui";
import * as _ from "lodash";
import {useHistory} from "react-router-dom";
import moment from 'moment';
import {observer} from 'mobx-react-lite';
import {Store} from "../../app/stores/store-root";

export type ExportReportRequest = {
    From: string;
    To: string;
}

const formValidation = yup.object().shape({
    From: yup.string().required('Starting date cannot be left blank'),
    To: yup.string().required('End date cannot be left blank'),
})
const OrdersExportContainer = () => {

    const [request] = useState<ExportReportRequest>({From: '', To: ''})
    const [startDate, setStartDate] = useState<moment.Moment>();
    const [endDate, setEndDate] = useState<moment.Moment>();
    const [loading, setLoading] = useState<boolean>(false);
    const[download, setDownload]= useState<string>();
    const[readyOrdersDownload, setreadyOrdersDownload]= useState<string>();
    const[dailyCashDownload, setDailyCashDownload]= useState<string>();
    const[dailyBankDownload, setDailyBankDownload]= useState<string>();
    const history = useHistory();
    const store = useContext(Store);

    const onFormSubmit = async (values: any) => {
        console.log(values);
        setLoading(true)
        store.Orders.ExportOrders(values).then((data)=>{
            setDownload(data.Result);
        })
        setLoading(false);
    }

    const onExportReadyOrdersClicked = async()=>{
        setLoading(true);
        console.log("date",startDate.format('DD-MM-YYYY') , endDate.format('DD-MM-YYYY'));
        store.Orders.ExportReadyOrders(startDate.format('YYYY-MM-DD') , endDate.format('YYYY-MM-DD')).then((data)=>{
            setreadyOrdersDownload(data.Result);
        })
        setLoading(false);
    }


    const onDailyExportClicked = async()=>{
        setLoading(true)
        store.Orders.ExportDailyCashOrders().then((data)=>{
            setDailyCashDownload(data.Result);
        })
        store.Orders.ExportDailyBankOrders().then((data)=>{
            setDailyBankDownload(data.Result);
        })
        setLoading(false);
    }

    const formik = useFormik({

        initialValues: request,
        onSubmit: onFormSubmit,
        validationSchema: formValidation,
        enableReinitialize: true

    });


    const onStartDateChanged = (date: moment.Moment) => {
        setStartDate(date)
        formik.getFieldHelpers('From').setValue(date);
    }

    const onEndDateChanged = (date: moment.Moment) => {
        setEndDate(date)
        formik.getFieldHelpers('To').setValue(date);
    }

    const breadcrumbs = [
        {
            text: 'Remittance App',
            href: '#',
            onClick: (e: any) => {
                e.preventDefault();
            },
            'data-test-subj': 'breadcrumbsAnimals',
        },
        {
            text: 'Export',
        },
    ];
    return (
        <div>
            <Fragment>
                <EuiPageContent>
                    <EuiBreadcrumbs
                        breadcrumbs={breadcrumbs}
                        truncate={false}
                        aria-label="An example of EuiBreadcrumbs"
                    />
                    <EuiSpacer size="xs"/>
                    <EuiPageContentHeader>
                        <EuiPageContentHeaderSection>
                            <EuiText>
                                <h1>{`Export Transfer Orders report`}</h1>
                                <p>
                                   The user can extract for any period between two dates. For monthly report user need to select the start date and end date before clicking to download the excel report.
                                </p>
                            </EuiText>
                        </EuiPageContentHeaderSection>
                    </EuiPageContentHeader>
                </EuiPageContent>
                <EuiSpacer/>
                <EuiPanel>
                    <EuiForm isInvalid={!formik.isValid && formik.submitCount > 0} error={_.values(formik.errors)}>
                        <form onSubmit={formik.handleSubmit}>
                            <EuiDescribedFormGroup title={<h3>Orders Export Duration</h3>}
                                                   description={
                                                       <Fragment>
                                                           For <b>Monthly report</b> select the start and end date for the calendar first!
                                                           <p>you can generate a report between any random periods when needed.</p>

                                                           <p>For <b>Daily report§</b> it will automatically pick current date only!</p>
                                                       </Fragment>
                                                   }>
                                <EuiFormRow label='Duration'
                                            isInvalid={((formik.getFieldMeta('Name').error) && (formik.getFieldMeta('Name').touched)) ? true : false}
                                            error={formik.getFieldMeta('Name').error}>


                                    <EuiDatePickerRange
                                        startDateControl={
                                            <EuiDatePicker
                                                selected={startDate}
                                                onChange={onStartDateChanged}
                                                startDate={startDate}
                                                endDate={endDate}
                                                //isInvalid={startDate > endDate}
                                                aria-label="Start date"
                                            />
                                        }
                                        endDateControl={
                                            <EuiDatePicker
                                                selected={endDate}
                                                onChange={onEndDateChanged}
                                                startDate={startDate}
                                                endDate={endDate}
                                                //isInvalid={startDate > endDate}
                                                aria-label="End date"
                                            />
                                        }
                                    />
                                </EuiFormRow>
                                {(download)?<EuiFormRow label={'Monthly Data Download Link'}>
                                    <EuiLink href={download} target="_blank">
                                        Click here to download the report
                                    </EuiLink>
                                </EuiFormRow>:''}

                                {(dailyCashDownload)?<EuiFormRow label={'Daily Cash Transfer Data Download Link'}>
                                    <EuiLink href={dailyCashDownload} target="_blank">
                                        Click here to download the report
                                    </EuiLink>
                                </EuiFormRow>:''}

                                {(dailyBankDownload)?<EuiFormRow label={'Daily Bank Transfer Data Download Link'}>
                                    <EuiLink href={dailyBankDownload} target="_blank">
                                        Click here to download the report
                                    </EuiLink>
                                </EuiFormRow>:''}

                                {(readyOrdersDownload)?<EuiFormRow label={'Daily zoba orders Link'}>
                                    <EuiLink href={readyOrdersDownload} target="_blank">
                                        Click here to download the orders
                                    </EuiLink>
                                </EuiFormRow>:''}


                            </EuiDescribedFormGroup>
                            <div className={'flex justify-end mt-8 space-x-4'}>
                                <EuiButton isLoading={loading} type='button' onClick={onExportReadyOrdersClicked}>
                                    Export ready orders
                                </EuiButton>
                                <EuiButton isLoading={loading} type='submit'>
                                    Export Monthly Data
                                </EuiButton>
                                <EuiButton isLoading={loading} type='button' onClick={onDailyExportClicked}>
                                    Export Daily Reports
                                </EuiButton>
                                <EuiButton isLoading={loading} type={"button"} onClick={() => {
                                    history.push('/');
                                }}>
                                    Cancel </EuiButton>
                            </div>
                        </form>
                    </EuiForm>
                </EuiPanel>
            </Fragment>
        </div>
    );
};

export default observer(OrdersExportContainer);
